import { useEffect } from 'react'
import { useSignal, batch } from '@preact/signals-react'
import {isEmpty, postSubmit, scrollToComponent} from '@ui-seeker/utils'
import {useAppToast} from "@ui-seeker/app";

import { isSystemBusy } from '@signals'
import { BACKEND_APIS } from '@constants'
import {customerDetailsFilters} from "../../@signals";


export default function useCustomersSiteTableFilters() {

    const { showToast } = useAppToast()
    const data = useSignal([])
    const isLoading = useSignal(false)

    useEffect(() => {
        if (!isEmpty(customerDetailsFilters.value)) batch(() => {
            isLoading.value = true
            showToast.promise(postSubmit(`${BACKEND_APIS.MANAGEMENT}/customer/customer-sites`, customerDetailsFilters.value)
                .then(res => {
                    data.value = res
                    isLoading.value = false
                })
                .catch(() => {
                    isSystemBusy.value = true
                }).finally(() => scrollToComponent('customer-sites-info'))
            )
        })

        if (isEmpty(customerDetailsFilters.value)) {
            data.value = {}
            isLoading.value = false
        }

    }, [JSON.stringify(customerDetailsFilters.value)])

    return {
        data: data.value,
        isLoading: isLoading.value
    }
}